import api, { transformRequest, transformResponse } from "services/api";

export const accountTyingRuleApi = api
  .enhanceEndpoints({
    addTagTypes: ["DebtorMergeGroupRules"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchDebtorMergeGroupRule: build.query({
        query: () => "api/v1/core/debtor-merge-rules/",
        transformResponse: (response) => transformResponse(response),
        providesTags: (results) =>
          results
            ? // successful query
              [
                ...results.map(({ id }) => ({ type: "DebtorMergeGroupRules", id })),
                { type: "DebtorMergeGroupRules", id: "LIST" },
              ]
            : // an error occurred, but we still want to refetch this query when `{ type: 'DebtorMergeGroupRules', id: 'LIST' }` is invalidated
              [{ type: "DebtorMergeGroupRules", id: "LIST" }],
      }),
      addDebtorMergeGroupRule: build.mutation({
        query: (payload) => ({
          url: "/api/v1/core/debtor-merge-rules/create/",
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: [{ type: "DebtorMergeGroupRules", id: "LIST" }],
      }),
      updateDebtorMergeGroupRule: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtor-merge-rules/${payload.id}/update/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: (result, error, arg) => [{ type: "DebtorMergeGroupRules", id: arg.id }],
      }),
      deleteDebtorMergeGroupRule: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtor-merge-rules/${payload.id}/delete/`,
          method: "POST",
          body: transformRequest(payload),
          headers: { "aktos-suppress-error": "true" },
        }),
        invalidatesTags: [{ type: "DebtorMergeGroupRules", id: "LIST" }],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useFetchDebtorMergeGroupRuleQuery,
  useAddDebtorMergeGroupRuleMutation,
  useDeleteDebtorMergeGroupRuleMutation,
  useUpdateDebtorMergeGroupRuleMutation,
} = accountTyingRuleApi;
